(function ($) {
    function handleError($cnt, xhr) {
        $cnt.find('.loading').removeClass('loading');
        var $error = $cnt.find('.error');

        var msg = 'Sorry! Failed to load. Please try again...';

        if (xhr.status === 400 && xhr.responseJSON.errors) {
            msg = xhr.responseJSON.errors[0].message;
        }

        $error.text(msg);
        $cnt
            .find('input')
            .addClass('error')
            .select()
            .focus();
    }

    function setCookie(name, value, expireInMinutes) {
        var d = new Date();
        d.setTime(d.getTime() + expireInMinutes * 60 * 1000);
        var expires = 'expires=' + d.toUTCString();
        document.cookie = name + '=' + value + ';' + expires + ';path=/';
    }

    function handleSucceed($cnt, rsp, postCode) {
        setCookie('LiveQuotesPostcode', postCode, 262800); // 6 months
        var content = $(rsp);
        $cnt.html(rsp);
        $cnt.find('.card').unwrap();
    }

    function handleSubmit(e) {
        e.preventDefault();
        var $container = $('.budget-direct-container');
        $container.find('.btn').addClass('loading');

        var $frm = $(e.target);
        var url = $frm.attr('action');
        var postCode = $frm.find('[name="PostCode"]').val();

        $.post(url, { postCode: postCode }, function (resp) {
            handleSucceed($container, resp, postCode);
        }).fail(function (xhr) {
            handleError($container, xhr);
        });
    }

    $(function () {
        $('body').on('submit', '.budget-direct-input form', function (e) {
            handleSubmit(e);
        });

        $('body').on('click', '#budgetDirectGetAQuote', function () {
            var img = '<img src="https://beacon.krxd.net/event.gif?event_id=MYdTgYYa&event_type=default" style="width: 0; height: 0; display: none;"/>';
            $('body').append(img);
        });
        
        $('body').on('click', '#budgetDirectInlineGetAQuote', function () {
            var img = '<img src="https://beacon.krxd.net/event.gif?event_id=MYdTgYYa&event_type=default" style="width: 0; height: 0; display: none;"/>';
            $('body').append(img);
        });
    });
})(jQuery);